import { render, staticRenderFns } from "./Bydownload.vue?vue&type=template&id=124a47ab&scoped=true"
import script from "./Bydownload.vue?vue&type=script&lang=js"
export * from "./Bydownload.vue?vue&type=script&lang=js"
import style0 from "./Bydownload.vue?vue&type=style&index=0&id=124a47ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a47ab",
  null
  
)

export default component.exports